import script from "./ViewSwitcher.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewSwitcher.vue?vue&type=script&setup=true&lang=js"

import "./ViewSwitcher.vue?vue&type=style&index=0&id=4aabe394&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4aabe394"]])

export default __exports__